<template>
  <div>
    <titulo-modulo :titulo="getNomeUsuarioLogado()" />
    <alerta-email v-if="usuarioLogado.email === '' && !gerencial" />
    <card-minha-matricula />
    <saldos-contas />
    <card-indicacao-pcd />
    <atalhos-rapidos />

    <modal-aviso-compras-prazo
      v-if="pendencias && pendencias.msg_aviso_senha_compra_prazo != ''"
    />
  </div>
</template>

<script>
import TituloModulo from "../../components/TituloModulo.vue";
import { mapActions, mapState } from "vuex";
import AtalhosRapidos from "./components/AtalhosRapidos.vue";
import SaldosContas from "./components/SaldosContas.vue";
import AlertaEmail from "./components/AlertaEmail.vue";
import CardIndicacaoPcd from "../indicar-pcd/components/CardIndicacaoPcd.vue";
import CardMinhaMatricula from "./components/CardMinhaMatricula.vue";
import ModalAvisoComprasPrazo from "../config-compras-prazo/components/ModalAvisoComprasPrazo.vue";

export default {
  components: {
    TituloModulo,
    AtalhosRapidos,
    SaldosContas,
    AlertaEmail,
    CardIndicacaoPcd,
    CardMinhaMatricula,
    ModalAvisoComprasPrazo,
  },
  computed: {
    ...mapState("usuario", ["usuarioLogado", "gerencial", "pendencias"]),
  },
  data: () => ({
    primeiroNomeColaborador: "",
    loading: true,
  }),
  methods: {
    ...mapActions("home", ["getTermosPendentes"]),
    ...mapActions("pcd", ["getConfigPcd"]),
    getNomeUsuarioLogado() {
      return `Olá, ${this.primeiroNomeColaborador}`;
    },
  },
  async mounted() {
    this.primeiroNomeColaborador = this.usuarioLogado.colaborador.split(" ")[0];

    await this.getConfigPcd();
  },
};
</script>

<style scoped>
</style>